import React from 'react';
import { ShouldRender } from '../../ui-core/ShouldRender';
import PropTypes from 'prop-types';
import { IMAGE_CONSTANT } from '../../constants/app';
import './style.css';
import Button from '../../ui-core/Button/Button';
import OfflineCartItem from './OfflineCartItem';
import { setItem } from '../../utils/cache';

const OfflineCartOffCanvas = ({ props, setIsOpen, isOpen, OfflineCart }) => {
  const handleClose = () => setIsOpen(!isOpen);
  const handleCheckout = () => {
    setItem('isOfflineCheckout', true);
    props?.onClick('LOGIN', 'isLogin', 'navigation header');
  };
  return (
    <ShouldRender check={isOpen}>
      <div className="off-canvas">
        <div className="off-canvas-backdrop" onClick={handleClose}></div>
        <div className="off-canvas-body">
          <div className="image-cross">
            <img
              alt="closeIcon"
              src={IMAGE_CONSTANT.crossIcon}
              onClick={handleClose}
            />
          </div>
          <div className="header">
            <img
              className="back-icon"
              onClick={handleClose}
              src={IMAGE_CONSTANT.backIcon}
            />
            <div className="off-canvas-title">Your Cart</div>
            <div className="cart-icon">
              <img
                alt="cart"
                className="cursor-pointer"
                src={IMAGE_CONSTANT.shoppingCartIcon}
                onClick={handleClose}
              />
              <ShouldRender check={OfflineCart?.length > 0}>
                <span className="items-count">{OfflineCart?.length}</span>
              </ShouldRender>
            </div>
          </div>
          <ShouldRender check={OfflineCart?.length === 0}>
            <div className="off-canvas-container">
              <img
                src={IMAGE_CONSTANT.emptyCartIcon}
                alt="empty cart"
                className="mb-4"
              />
              <p>There are no items in your cart</p>
              {/* <Button
                          text="ADD ITEMS"
                          onClick={handleClick}
                          class="sign-up-button-new text-uppercase mt-2 w-auto px-3"
                        /> */}
            </div>
          </ShouldRender>
          <ShouldRender check={OfflineCart?.length > 0}>
            <div className="cart-items-wrapper">
              <OfflineCartItem selectedProducts={OfflineCart} />
            </div>
            <div className="checkout-wrapper mt-2">
              {/* <Button
                          text={`View Cart${itemsCount ? ' (' + itemsCount + ')' : ''} `}
                          onClick={handleClick}
                          class="view-button"
                        /> */}
              <Button
                text="CHECKOUT"
                onClick={handleCheckout}
                class="sign-up-button-new"
                //   isLoading={isLoading}
                //   isDisabled={isLoading}
              />
            </div>
          </ShouldRender>
        </div>
      </div>
    </ShouldRender>
  );
};

OfflineCartOffCanvas.propTypes = {
  setIsOpen: PropTypes.func,
  isOpen: PropTypes.bool,
  OfflineCart: PropTypes.array,
  props: PropTypes.object,
  onClick: PropTypes.func,
};

export default OfflineCartOffCanvas;
